"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

exports.__esModule = true;
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

var P = _interopRequireWildcard(require("@react-pdf/primitives"));

var isPolyline = R.propEq('type', P.Polyline);
var _default = isPolyline;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@react-pdf/render/lib/utils/isPolyline.js
// module id = 221
// module chunks = 0